import { render, staticRenderFns } from "./MfaTelegramEnrollStep.vue?vue&type=template&id=42eecd8b&"
import script from "./MfaTelegramEnrollStep.vue?vue&type=script&lang=js&"
export * from "./MfaTelegramEnrollStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports